import { isIdEqual } from 'modules/enumerations/enumerationHelpers';

// Title company addresses are saved as US addresses (see MorrealeIntegrationService), so only US states are offered.
const UNITED_STATES_COUNTRY_ID = 'D94A0819-59A2-443F-BC99-1EE360057F38';

export const CreateApprovalFormFields = homeSaleData => {
  return {
    tabs: [{ header: 'TRC Contract', order: 1, iconPath: ['fas', 'house'] }],
    summaries: [
      {
        header: 'GBO Appraised Value',
        accessorKey: 'appraisalValue',
        type: 'money',
        requried: false,
        value: homeSaleData?.appraisalValue,
        tab: 1
      },
      {
        header: 'BVO/GBO Offer Amount',
        accessorKey: 'offerAmount',
        type: 'money',
        requried: false,
        value: homeSaleData?.offerAmount,
        tab: 1
      },
      {
        header: 'BVO/GBO Offer Date',
        accessorKey: 'offerDate',
        type: 'date',
        requried: false,
        value: homeSaleData?.offerDate,
        tab: 1
      },
      {
        header: 'Days Offer Valid',
        accessorKey: 'daysOfferValid',
        type: 'text',
        requried: false,
        value: homeSaleData?.daysOfferValid,
        tab: 1
      },
      // {
      //   header: 'Offer Sent',
      //   accessorKey: 'offerSentDate',
      //   type: 'date',
      //   requried: false,
      //   value: homeSaleData?.offerSentDate,
      //   tab: 1,
      // },
      // {
      //   header: 'Offer Sent To',
      //   accessorKey: 'offerSentTo',
      //   type: 'text',
      //   requried: false,
      //   value: homeSaleData?.offerSentTo,
      //   tab: 1,
      // },
      //       {
      //   header: 'Offer Sent Via',
      //   accessorKey: 'offerSentVia',
      //   type: 'text',
      //   requried: false,
      //   value: homeSaleData?.offerSentVia,
      //   tab: 1,
      // },
      {
        header: 'Client Approved Date',
        accessorKey: 'clientApprovedDate',
        type: 'date',
        requried: false,
        value: homeSaleData?.clientApprovedDate,
        tab: 1
      },
      {
        header: 'Client Approved By',
        accessorKey: 'clientApprovedBy',
        type: 'dropdown-v2',
        requried: false,
        value: homeSaleData?.clientApprovedBy,
        options: [{ id: 1, title: 'Sample One' }, { id: 2, title: 'Sample Two' }, { id: 3, title: 'Sample Three' }],
        tab: 1
      },
      {
        header: 'Approval Concessions',
        accessorKey: 'approvalConcessions',
        type: 'money',
        requried: false,
        value: homeSaleData?.approvalConcessions,
        tab: 1
      },
      {
        header: 'Initial Bill Date',
        accessorKey: 'initialBillDate',
        type: 'date',
        requried: false,
        value: homeSaleData?.initialBillDate,
        tab: 1
      },
      {
        header: 'Contingencies',
        accessorKey: 'contingencies',
        type: 'notes',
        requried: false,
        value: homeSaleData?.contingencies,
        tab: 1
      },
      {
        header: 'Offer Sent',
        accessorKey: 'offerSentDate',
        type: 'date',
        requried: false,
        value: homeSaleData?.offerSentDate,
        tab: 1,
      },
      { dividerLine: true, tab: 1 },
      {
        header: 'Personal Property Included',
        accessorKey: 'personalPropertyIncluded',
        type: 'notes',
        requried: false,
        value: homeSaleData?.personalPropertyIncluded,
        tab: 1
      },
      {
        header: 'Personal Property Excluded',
        accessorKey: 'personalPropertyExcluded',
        type: 'notes',
        requried: false,
        value: homeSaleData?.personalPropertyExcluded,
        tab: 1
      },
      // {
      //   header: 'Subject To',
      //   accessorKey: 'appSubjectTo',
      //   type: 'text',
      //   requried: false,
      //   value: homeSaleData?.appSubjectTo,
      //   tab: 1
      // },
    ],
  };
};

export const CreateAcceptanceFormFields = (homeSaleData, enumerations) => {
  const saleTypes = enumerations?.allEnums?.saleTypes;
  const saleTypeOptions =
    saleTypes && saleTypes.length > 0
      ? saleTypes.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  return {
    tabs: [{ header: 'Acquisition', order: 1, iconPath: ['fas', 'money-bill-transfer'] }],
    summaries: [
      {
        // Mirrors the homesale's Sale Type (Primary tab); it is stored once, on the homesale record.
        header: 'Sale Type',
        accessorKey: 'saleTypeId',
        type: 'dropdown-v2',
        required: false,
        value: homeSaleData?.saleTypeId ?? null,
        options: saleTypeOptions,
        tab: 1
      },
      {
        header: 'TRC Acquisition Amount',
        accessorKey: 'offerAcceptAmount',
        type: 'money',
        requried: false,
        value: homeSaleData?.offerAcceptAmount,
        tab: 1
      },
      {
        header: 'Verbal Offer Accepted',
        accessorKey: 'verbalOfferAcceptDate',
        type: 'date',
        requried: false,
        value: homeSaleData?.verbalOfferAcceptDate,
        tab: 1
      },
      {
        header: 'GBO Offer Accepted',
        accessorKey: 'offerAcceptDate',
        type: 'date',
        requried: false,
        value: homeSaleData?.offerAcceptDate,
        tab: 1
      },
      {
        header: 'Directed Offer',
        accessorKey: 'directedEquity',
        type: 'money',
        requried: false,
        value: homeSaleData?.directedEquity,
        tab: 1
      },
      {
        header: 'Concessions',
        accessorKey: 'acceptanceConcessions',
        type: 'money',
        requried: false,
        value: homeSaleData?.acceptanceConcessions,
        tab: 1
      },
      {
        header: 'Home Warranty',
        accessorKey: 'buyoutHomeWarranty',
        type: 'money',
        requried: false,
        value: homeSaleData?.buyoutHomeWarranty,
        tab: 1
      },
      {
        header: 'Repairs',
        accessorKey: 'buyoutRepairs',
        type: 'notes',
        requried: false,
        value: homeSaleData?.buyoutRepairs,
        tab: 1
      },
      {
        header: 'Repair Amount',
        accessorKey: 'repairsAmount',
        type: 'money',
        required: false,
        value: homeSaleData?.repairsAmount,
        tab: 1,
      },
      {
        header: 'Buyout Agreement Received',
        accessorKey: 'buyoutAgreementReceived',
        type: 'date',
        requried: false,
        value: homeSaleData?.buyoutAgreementReceived,
        tab: 1
      },
      {
        header: 'Vacate',
        accessorKey: 'vacateDate',
        type: 'date',
        requried: false,
        value: homeSaleData?.vacateDate,
        tab: 1,
      },
      {
        header: 'Proration',
        accessorKey: 'prorateDate',
        type: 'date',
        requried: false,
        value: homeSaleData?.prorateDate,
        tab: 1
      },
      {
        header: 'Possession',
        accessorKey: 'posessionDate',
        type: 'date',
        requried: false,
        value: homeSaleData?.posessionDate,
        tab: 1
      },
     {
        header: 'Actual Buyout Close',
        accessorKey: 'actualBuyoutCloseDate',
        type: 'date',
        value: homeSaleData?.actualBuyoutCloseDate ?? null,
        required: false,
        tab: 1
      },
      {
        header: 'Fund',
        accessorKey: 'fundDate',
        type: 'date',
        requried: false,
        value: homeSaleData?.fundDate,
        tab: 1
      },
      {
        header: 'Insure',
        accessorKey: 'insureDate',
        type: 'date',
        requried: false,
        value: homeSaleData?.insureDate,
        tab: 1
      },
      {
        header: 'End Insure',
        accessorKey: 'endInsureDate',
        type: 'date',
        requried: false,
        value: homeSaleData?.endInsureDate,
        tab: 1
      },
      {
        header: 'Re-Appraisal Ordered',
        accessorKey: 'reAppraisalOrderedDate',
        type: 'date',
        requried: false,
        value: homeSaleData?.reAppraisalOrderedDate,
        tab: 1
      },
      {
        header: 'GBO Offer Decision',
        accessorKey: 'offerDecision',
        type: 'dropdown',
        required: false,
        options: ['Accepted', 'Declined', 'Not Started', 'Started but not extended'],
        tab: 1,
        value: homeSaleData?.offerDecision,
      },    
      {
        header: 'Offer Extended',
        accessorKey: 'offerRejectedDate',
        type: 'date',
        requried: false,
        value: homeSaleData?.offerRejectedDate,
        tab: 1
      },
      {
        header: 'Offer Expires',
        accessorKey: 'offerExpiresDate',
        type: 'date',
        requried: false,
        value: homeSaleData?.offerExpiresDate,
        tab: 1
      },  
      {
        header: 'Offer Follow Up',
        accessorKey: 'offerFollowupDate',
        type: 'date',
        requried: false,
        value: homeSaleData?.offerFollowupDate,
        tab: 1
      },
      {
        header: 'Offer Ext Granted',
        accessorKey: 'offerExtensionGranted',
        type: 'date',
        requried: false,
        value: homeSaleData?.offerExtensionGranted,
        tab: 1
      },
      {
        header: 'Offer Ext Expires',
        accessorKey: 'offerExtensionExpires',
        type: 'date',
        requried: false,
        value: homeSaleData?.offerExtensionExpires,
        tab: 1
      },
      // {
      //   header: 'AVS Accept Amount',
      //   accessorKey: 'avsAcceptAmount',
      //   type: 'money',
      //   requried: false,
      //   value: homeSaleData?.avsAcceptAmount,
      //   tab: 1
      // },
      // {
      //   header: 'Hire Status',
      //   accessorKey: 'hireStatus',
      //   type: 'text',
      //   requried: false,
      //   value: homeSaleData?.hireStatus,
      //   tab: 1
      // },
    ],
  };
};

export const CreatePersonalPropertyFormFields = homeSaleData => {
  return {
    tabs: [{ header: 'Personal Property', order: 1, iconPath: ['fas', 'suitcase-rolling'] }],
    summaries: [
      {
        header: 'Personal Property Included',
        accessorKey: 'personalPropertyIncluded',
        type: 'text',
        requried: false,
        value: homeSaleData?.personalPropertyIncluded,
        tab: 1
      },
      {
        header: 'Personal Property Excluded',
        accessorKey: 'personalPropertyExcluded',
        type: 'text',
        requried: false,
        value: homeSaleData?.personalPropertyExcluded,
        tab: 1
      }
    ]
  };
};

export const CreateTitleFormFields = (homeSaleData, titleReps, vendors, enumerations) => {
  titleReps = titleReps ?? [];

  const stateOptions = (enumerations?.allEnums?.provinces ?? []).filter(
    p => p.isActive === true && isIdEqual(p.countryId, UNITED_STATES_COUNTRY_ID)
  );

  return {
    tabs: [
      { header: 'Local Title Co.', order: 1, iconPath: ['fas', 'money-bill-transfer'] }
    ],
    summaries: [
      {
        header: 'Title Company Name',
        accessorKey: 'titleCompanyName',
        type: 'text',
        required: false,
        value: homeSaleData?.titleCompanyName,
        hideInCard: false,
        tab: 1
      },
      {
        header: 'Title Company Address',
        accessorKey: 'titleCompanyAddress',
        type: 'text',
        required: false,
        value: `${homeSaleData?.titleAddressLineOne ?? ''} ${homeSaleData?.titleAddressLineTwo ?? ''}, ${homeSaleData?.titleAddressCity ?? ''}, ${enumerations?.allEnums?.provinces?.find(p => p.id === homeSaleData?.titleAddressProvinceId)?.title ?? ''}, ${enumerations?.allEnums?.countries?.find(c => c.id === homeSaleData?.titleAddressCountryId)?.title ?? ''} ${homeSaleData?.titleAddressZipcode ?? ''}`,
        hideInModal: true,
        tab: 1
      },
      // The address is shown above as one line and edited as separate fields.
      {
        header: 'Address Line 1',
        accessorKey: 'titleAddressLineOne',
        type: 'text',
        required: false,
        value: homeSaleData?.titleAddressLineOne ?? '',
        hideInTable: true,
        tab: 1
      },
      {
        header: 'Address Line 2',
        accessorKey: 'titleAddressLineTwo',
        type: 'text',
        required: false,
        value: homeSaleData?.titleAddressLineTwo ?? '',
        hideInTable: true,
        tab: 1
      },
      {
        header: 'City',
        accessorKey: 'titleAddressCity',
        type: 'text',
        required: false,
        value: homeSaleData?.titleAddressCity ?? '',
        hideInTable: true,
        tab: 1
      },
      {
        header: 'State',
        accessorKey: 'titleAddressProvinceId',
        type: 'dropdown-v2',
        required: false,
        value: homeSaleData?.titleAddressProvinceId ?? null,
        options: stateOptions,
        hideInTable: true,
        tab: 1
      },
      {
        header: 'Zip Code',
        accessorKey: 'titleAddressZipcode',
        type: 'text',
        required: false,
        value: homeSaleData?.titleAddressZipcode ?? '',
        hideInTable: true,
        tab: 1
      },
      {
        header: 'Ordered Date',
        accessorKey: 'titleOrderedDate',
        type: 'date',
        required: false,
        value: homeSaleData?.titleOrderedDate,
        tab: 1
      },
      {
        header: 'Due Date',
        accessorKey: 'titleDueDate',
        type: 'date',
        required: false,
        value: homeSaleData?.titleDueDate,
        tab: 1
      },
      {
        header: 'Received Date',
        accessorKey: 'titleReceivedDate',
        type: 'date',
        required: false,
        value: homeSaleData?.titleReceivedDate,
        tab: 1
      },
      {
        header: 'Order Number',
        accessorKey: 'titleOrderNumber',
        type: 'text',
        required: false,
        value: homeSaleData?.titleOrderNumber,
        tab: 1
      },
      {
        header: 'Title Doc Sent To',
        accessorKey: 'titleDocsSentTo',
        type: 'text',
        required: false,
        value: homeSaleData?.titleDocsSentTo,
        tab: 1
      },
      {
        header: 'Sent for Signature Date',
        accessorKey: 'titleDocsSentForSignature',
        type: 'date',
        required: false,
        value: homeSaleData?.titleDocsSentForSignature,
        tab: 1
      },
      {
        header: 'Received Back Date',
        accessorKey: 'titleDocsReceivedBackDate',
        type: 'date',
        required: false,
        value: homeSaleData?.titleDocsReceivedBackDate,
        tab: 1
      },
      {
        header: 'Title Deadline',
        accessorKey: 'titleDeadline',
        type: 'date',
        requried: false,
        value: homeSaleData?.titleDeadline,
        tab: 1
      },
      {
        header: 'Inspection Objection',
        accessorKey: 'inspectionObjectionDeadline',
        type: 'date',
        requried: false,
        value: homeSaleData?.inspectionObjectionDeadline,
        tab: 1
      },
      {
        header: 'Resolution',
        accessorKey: 'resolution',
        type: 'date',
        requried: false,
        value: homeSaleData?.resolution,
        tab: 1
      }
    ]
  };
};
